import { authClient } from '../lib/auth-client'

export async function authHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await authClient.getSession()
  return session?.access_token
    ? { 'Authorization': `Bearer ${session.access_token}` }
    : {}
}

/**
 * Call after any fetch that returns 401 — triggers a session refresh.
 * If refresh succeeds, returns true (caller should retry the request).
 * If refresh fails, clears session and reloads to bounce to login.
 */
export async function handleUnauthorized(): Promise<boolean> {
  // getSession() already attempts refresh internally.
  // If it returns a session, the retry will use the fresh token.
  const { data: { session } } = await authClient.getSession()
  if (session) return true

  // Refresh failed — clear session. React auth state listener
  // will redirect to login automatically (no reload needed).
  await authClient.signOut()
  return false
}
